<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      finish-button-text="Simpan"
      back-button-text="Sebelumnya"
      next-button-text="Selanjutnya"
      class="steps-transparent mb-3"
      @on-complete="submitForm"
      ref="form"
    >
      <tab-content
        title="Esai"
        icon="feather icon-book-open"
        :before-change="validationFormEsai"
      >
        <validation-observer
          ref="dataEsaiRules"
          tag="form"
        >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
             Form Esai
            </h5>
            <small class="text-muted">
              Silahkan merespon dua pertanyaan esai di bawah ini. Jumlah kata yang di perkenankan untuk menjawab kedua pertanyaan ini adalah 1200 kata.
            </small>
            <br/>
            <small>
              (Jawaban yang terindikasi menggunakan AI/ChatGPT akan didiskualifikasi)
            </small>
          </b-col>  
        </b-row>
        <b-row v-if="esai">
          <b-col
            cols="12"
            class="mb-2"
            v-for="(item_esai, index) in esai" :key="index" >
            <!-- Alasan Peminatan -->
            <b-form-group :label="`${index + 1}. ${item_esai.nama}`" >
              <div v-if="item_esai.tipe === 'textarea'">
                <validation-provider
                  #default="{ errors }"
                  name="Form"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                <b-form-textarea v-model="esai[index].jawaban" @change="handleChangeAsessment(item_esai.assessment_uuid, esai[index].jawaban)" ></b-form-textarea>
                 <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
              <div  v-if="item_esai.tipe === 'text'">
                <b-form-input v-model="esai[index].jawaban" @change="handleChangeAsessment(item_esai.assessment_uuid, esai[index].jawaban)" ></b-form-input>
              </div>
            </b-form-group>
          </b-col>  
        </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
        title="Profil Kepribadian"
        icon="feather icon-check"
      >   
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Profil Kepribadian
            </h5>
            <small class="text-muted">
              Bagian ini terdiri dari 20 pernyataan dan Anda diminta untuk memberikan jawaban yang paling menggambarkan diri. Kata "Saya" dalam pernyataan-pernyataan di bawah merujuk pada diri Anda. Deskripsikan diri Anda secara jujur seperti diri Anda sekarang, bukan seperti diri yang Anda inginkan di masa depan. Bacalah tiap penyataan secara hati-hati kemudian pilihlah satu dari enam pilihan jawaban yang paling menggambarkan diri Anda.
            </small>
          </b-col>  
        </b-row>
        <b-row v-if="profilKepribadian">
          <b-col
            cols="8"
            class="mb-2"
            v-for="(item_profil_kepribadian, indexprofil) in profilKepribadian" :key="indexprofil" >
            <!-- Alasan Peminatan -->
            <b-form-group :label="`${indexprofil +1}. ${item_profil_kepribadian.nama}`"  >
              <div v-if="item_profil_kepribadian.tipe === 'textarea'">
                <b-form-textarea v-model="profilKepribadian[indexprofil].jawaban" @change="handleChangeAsessment(item_profil_kepribadian.assessment_uuid, profilKepribadian[indexprofil].jawaban)" ></b-form-textarea>
              </div>
              <div  v-if="item_profil_kepribadian.tipe === 'text'">
                <b-form-input v-model="profilKepribadian[indexprofil].jawaban" @change="handleChangeAsessment(item_profil_kepribadian.assessment_uuid, profilKepribadian[indexprofil].jawaban)" ></b-form-input>
              </div>
              <div  v-if="item_profil_kepribadian.tipe === 'range'">
                <div class="d-flex justify-content-between align-items-center">
                  <div>Sangat Tidak Sesuai</div>
                  <div>Sangat Sesuai</div>
                </div>
                <b-form-input type="range" v-model="profilKepribadian[indexprofil].jawaban" min="1" max="10" @change="handleChangeAsessment(item_profil_kepribadian.assessment_uuid, profilKepribadian[indexprofil].jawaban)" ></b-form-input>
                <div class="d-flex justify-content-between">
                  <div>1</div>
                  <div>6</div>
                </div>
              </div>
            </b-form-group>
          </b-col>  
        </b-row>

      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/id.js'; // Import Indonesian language pack
import {
  getAssessment,
  patchAssessment,
  updateStatusAssessment,
} from '@/connection-api/assessment'
import {
  required,
  integer,
  regex,
  confirmed,
  email
} from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});

import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormTextarea,
  BButton,
  BFormDatepicker,
  BMedia, BMediaAside, BMediaBody,
  BFormFile,
  BImg,
  BFormSelect,
  BTable,
  BLink,
} from 'bootstrap-vue';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    FlatPickr,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormTextarea,
    BButton,
    BFormDatepicker,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BMedia, BMediaAside, BMediaBody,
    BFormFile,
    BImg,
    BFormSelect,
    BTable,
    BLink,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      required,
      integer,
      regex,
      confirmed,
      email,
      flatpickrConfig: {
        altInput: true,
        altFormat: 'j F Y', // Indonesian date format
        dateFormat: 'Y-m-d', // Actual date format used for the form
        locale: 'id', // Set locale to Indonesian
      },
      profilKepribadian: [],
      esai: [],
    };
  },
  mounted() {
    this.getDataAssessment();
  },
  methods: {
    async getDataAssessment()
    {
      const responseEsai = await getAssessment({ group: 'esai' });
      if(responseEsai.data)
      {
        this.esai = responseEsai.data.data;
      }
      const response = await getAssessment({ group: 'profile' });
      if (response.data) {
        this.profilKepribadian = response.data.data;
      }
    },
    async submitForm() {
      this.$bvModal.msgBoxOk('Data Assessment berhasil disimpan.', {
        title: 'Sukses',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false
      });
      setTimeout(() => {
        this.$router.go(0)
      }, 3000);
    },
    async handleChangeAsessment(uuid, value) {
      const data = {assessment_uuid: uuid, jawaban: value}
      const response = await patchAssessment(data); 
    },
    validationFormEsai() {
      return new Promise((resolve, reject) => {
        this.$refs.dataEsaiRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormDataKeluarga() {
      return new Promise((resolve, reject) => {
        this.$refs.dataKeluargaRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  }
};
</script>
